import { types } from 'mobx-state-tree';

export default types.model('DifferenceModel', {
  qty: types.optional(types.maybeNull(types.number), 0),
  amount: types.optional(types.maybeNull(types.number), 0),
});
